import React, { useState, useEffect } from 'react';
import { PDFViewer } from '@react-pdf/renderer';
import { useLocation } from 'react-router-dom';
import EtiquetaEmpaqueDocument from './EtiquetaEmpaqueDocument';
import logoDux from '../logoduxazul.png';

const LOGO_VALIDATION_TIMEOUT_MS = 5000;

const validateLogoUrl = (logoUrl) => {
  if (!logoUrl) {
    return Promise.resolve(null);
  }

  return new Promise((resolve) => {
    const image = new window.Image();
    const timer = setTimeout(() => {
      image.onload = null;
      image.onerror = null;
      resolve(null);
    }, LOGO_VALIDATION_TIMEOUT_MS);

    image.onload = () => {
      clearTimeout(timer);
      resolve(logoUrl);
    };
    image.onerror = () => {
      clearTimeout(timer);
      resolve(null);
    };
    image.src = logoUrl;
  });
};

const resolveLogoUrl = async (data) => {
  return (
    await validateLogoUrl(data?.remitente_logo_sucursal_url)
    || await validateLogoUrl(data?.remitente_logo_empresa_url)
    || logoDux
  );
};

const EtiquetaEmpaqueViewer = () => {
  const location = useLocation();
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    document.title = 'Etiqueta de Empaque';
  }, []);

  useEffect(() => {
    let isMounted = true;

    const loadEtiqueta = async () => {
      setIsLoading(true);
      setError(null);

      const tokenParam = new URLSearchParams(location.search).get('token');

      if (!tokenParam) {
        setError('No se proporcionó un token de acceso.');
        setIsLoading(false);
        return;
      }

      try {
        const response = await fetch(`${window._env_.REACT_APP_BACKEND_URL}/empaque/etiqueta-empaque?token=${encodeURIComponent(tokenParam)}`);

        if (!response.ok) {
          throw new Error(`Error ${response.status}: No se pudo obtener la información`);
        }

        const json = await response.json();
        const resolvedLogoUrl = await resolveLogoUrl(json);

        if (!isMounted) {
          return;
        }

        setData({ ...json, resolvedLogoUrl });
        setIsLoading(false);
      } catch (err) {
        if (!isMounted) {
          return;
        }

        setError(err.message);
        setIsLoading(false);
      }
    };

    loadEtiqueta();

    return () => {
      isMounted = false;
    };
  }, [location.search]);

  if (isLoading) {
    return (
      <div style={{ padding: 40, fontFamily: 'sans-serif', color: '#555' }}>
        Cargando etiqueta...
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ padding: 40, fontFamily: 'sans-serif', color: '#c00' }}>
        <strong>Error:</strong> {error}
      </div>
    );
  }

  if (!data) {
    return (
      <div style={{ padding: 40, fontFamily: 'sans-serif', color: '#888' }}>
        No hay datos para mostrar.
      </div>
    );
  }

  return (
    <PDFViewer style={{ width: '100%', height: '100vh', border: 'none' }}>
      <EtiquetaEmpaqueDocument data={data} logoUrl={data.resolvedLogoUrl} observacionesEnvio={data.observaciones_envio} />
    </PDFViewer>
  );
};

export default EtiquetaEmpaqueViewer;
